import AppContainer from '../basicLayout/AppContainer'
export default [
	{
		path: '/logisticsSys',
		name: 'logistics_sys_management',
		component: AppContainer,
		meta: {
			title: '系统管理'
		},
		children: [
			{
				path: 'logisticsDept',
				name: 'LogisticsDept',
				meta: {
					title: '部门管理'
				},
				component: resolve => require(['@/views/logistics/sys/org/index.vue'], resolve)
			},
			{
				path: 'logisticsRole',
				meta: {
					title: '角色管理'
				},
				name: 'LogisticsRole',
				component: resolve => require(['@/views/logistics/sys/role/index.vue'], resolve)
			},

			{
				path: 'logisticsUser',
				meta: {
					title: '用户管理'
				},
				name: 'LogisticsUser',
				component: resolve => require(['@/views/logistics/sys/user/index.vue'], resolve)
			},
			{
				path: 'logisticsPost',
				meta: {
					title: '岗位管理'
				},
				name: 'LogisticsPost',
				component: resolve => require(['@/views/logistics/sys/post/index.vue'], resolve)
			},
			{
				path: 'logisticsDict',
				meta: {
					title: '字典管理'
				},
				name: 'LogisticsDict',
				component: resolve => require(['@/views/logistics/sys/dict/index.vue'], resolve)
			}
		]
	},
	//日志管理
	{
		path: '/logisticsLog',
		name: 'logistics_log_management',
		component: AppContainer,
		meta: {
			title: '日志管理'
		},
		children: [
			{
				path: 'logisticsOperlog',
				meta: {
					title: '操作日志'
				},
				name: 'LogisticsOperlog',
				component: resolve => require(['@/views/logistics/log/operlog.vue'], resolve)
			},
			{
				path: 'logisticsUpdatelog',
				meta: {
					title: '更新日志'
				},
				name: 'LogisticsUpdatelog',
				component: resolve => require(['@/views/logistics/log/updateLog.vue'], resolve)
			}
		]
	},

	//资料管理
	{
		path: '/logisticsInformation',
		name: 'logistics_information_management',
		component: AppContainer,
		meta: {
			title: '资料管理'
		},
		children: [
			{
				path: 'logisticsVehicleType',
				meta: {
					title: '车辆类型'
				},
				name: 'LogisticsVehicleType',
				component: resolve => require(['@/views/logistics/information/vehicleType/index.vue'], resolve)
			},
			{
				path: 'logisticsClientManagement',
				meta: {
					title: '客户管理'
				},
				name: 'LogisticsClientManagement',
				component: resolve => require(['@/views/logistics/information/clientManagement/index.vue'], resolve)
			},

			{
				path: 'logisticsProject',
				meta: {
					title: '项目管理'
				},
				name: 'LogisticsProject',
				component: resolve => require(['@/views/logistics/information/project/index.vue'], resolve)
			},
			{
				path: 'logisticsVehicleManagement',
				meta: {
					title: '车辆管理'
				},
				name: 'LogisticsVehicleManagement',
				component: resolve => require(['@/views/logistics/information/vehicleManagement/index.vue'], resolve)
			},
			{
				path: 'logisticsDriverManagement',
				meta: {
					title: '驾驶员管理'
				},
				name: 'LogisticsDriverManagement',
				component: resolve => require(['@/views/logistics/information/driver/index.vue'], resolve)
			},

			{
				path: 'logisticsTransportRoute',
				meta: {
					title: '运输路线'
				},
				name: 'LogisticsTransportRoute',
				component: resolve => require(['@/views/logistics/information/transportRoute/index.vue'], resolve)
			},
			{
				path: 'logisticsRouteAudit',
				meta: {
					title: '路线审核'
				},
				name: 'LogisticsRouteAudit',
				component: resolve => require(['@/views/logistics/information/routeAudit/index.vue'], resolve)
			},
			{
				path: 'logisticsRouteRiskManagement',
				meta: {
					title: '路线风控'
				},
				name: 'LogisticsRouteRiskManagement',
				component: resolve => require(['@/views/logistics/information/routeRiskManagement/index.vue'], resolve)
			},
			{
				path: 'logisticsdriverCarBind',
				meta: {
					title: '车辆组合及绑定'
				},
				name: 'LogisticsDriverCarBind',
				component: resolve => require(['@/views/logistics/information/driverCarBind/index.vue'], resolve)
			},
				{
				path: 'logisticsDriverVehicleBind',
				meta: {
					title: '驾驶员车辆绑定'
				},
				name: 'LogisticsDriverVehicleBind',
				component: resolve => require(['@/views/logistics/information/driverVehicleBind/index.vue'], resolve)
			},
			{
				path: 'logisticsWarehouse',
				meta: {
					title: '仓库管理'
				},
				name: 'LogisticsWarehouse',
				component: resolve => require(['@/views/logistics/information/warehouse/index.vue'], resolve)
			},
			{
				path: 'logisticsWeather',
				meta: {
					title: '天气管理'
				},
				name: 'LogisticsWeather',
				component: resolve => require(['@/views/logistics/information/weather/index.vue'], resolve)
			}
		]
	},


	//轮胎管理
	{
		path: '/logisticsTire',
		name: 'logistics_tire',
		component: AppContainer,
		meta: {
			title: '轮胎管理'
		},
		children: [
			{
				path: 'logisticsTireList',
				meta: {
					title: '轮胎列表'
				},
				name: 'LogisticsTireList',
				component: resolve => require(['@/views/logistics/tire/tireList'], resolve)
			},
			{
				path: 'logisticsTireLedger',
				meta: {
					title: '轮胎台账'
				},
				name: 'LogisticsTireLedger',
				component: resolve => require(['@/views/logistics/tire/tireLedger'], resolve)
			}
		]
	},


	//业务管理
	{
		path: '/logisticsBusinessManagement',
		name: 'logistics_business_management',
		component: AppContainer,
		meta: {
			title: '业务管理'
		},
		children: [
			{
				path: 'vehicleIdentificationReminder',
				meta: {
					title: '车辆证照提醒'
				},
				name: 'VehicleIdentificationReminder',
				component: resolve => require(['@/views/logistics/businessManagement/vehicleIdentificationReminder/index.vue'], resolve)
			},
			{
				path: 'driverReminder',
				meta: {
					title: '驾驶员证照提醒'
				},
				name: 'DriverReminder',
				component: resolve => require(['@/views/logistics/businessManagement/driverReminder/index.vue'], resolve)
			},
			{
				path: 'logisticsOrder',
				meta: {
					title: '订单'
				},
				name: 'LogisticsOrder',
				component: resolve => require(['@/views/logistics/businessManagement/order/index.vue'], resolve)
			},
			{
				path: 'logisticsOrderScheduling',
				meta: {
					title: '订单调度'
				},
				name: 'LogisticsOrderScheduling',
				component: resolve => require(['@/views/logistics/businessManagement/dispatchNew/index.vue'], resolve)
			},
			{
				path: 'logisticsWayBill',
				meta: {
					title: '运单管理'
				},
				name: 'LogisticsWayBill',
				component: resolve => require(['@/views/logistics/businessManagement/waybill/index.vue'], resolve)
			},
			{
				path: 'logisticsWayBillModify',
				meta: {
					title: '运单修改'
				},
				name: 'LogisticsWayBillModify',
				component: resolve => require(['@/views/logistics/businessManagement/waybillModify/index.vue'], resolve)
			},
			{
				path: 'overtimeLogisticsWayBill',
				meta: {
					title: '超时运单'
				},
				name: 'OvertimeLogisticsWayBill',
				component: resolve => require(['@/views/logistics/businessManagement/overtimeWaybill/index.vue'], resolve)
			},
			{
				path: 'logisticsDriverError',
				meta: {
					title: '违章管理'
				},
				name: 'LogisticsDriverError',
				component: resolve => require(['@/views/logistics/businessManagement/driverError/index.vue'], resolve)
			},
			{
				path: 'logisticsCancelOrder',
				meta: {
					title: '违章管理'
				},
				name: 'LogisticsCencleOrder',
				component: resolve => require(['@/views/logistics/businessManagement/cancelOrder/index.vue'], resolve)
			},
			{
				path: 'logisticsRouteTransportCapacity',
				meta: {
					title: '路线运力配置'
				},
				name: 'LogisticsRouteTransportCapacity',
				component: resolve => require(['@/views/logistics/businessManagement/routeTransportCapacity/index.vue'], resolve)
			},
			{
				path: 'logisticsExceptionReport',
				meta: {
					title: '异常管理'
				},
				name: 'LogisticsExceptionReport',
				component: resolve => require(['@/views/logistics/businessManagement/exceptionReport/index.vue'], resolve)
			},
		]
	},
	//运营管理
	{
		path: '/logisticsOperationManagement',
		name: 'logistics_operation_management',
		component: AppContainer,
		meta: {
			title: '运营管理'
		},
		children: [
			{
				path: 'logisticsMileageData',
				meta: {
					title: '里程数据'
				},
				name: 'LogisticsMileageData',
				component: resolve => require(['@/views/logistics/operationManagement/mileageData/index.vue'], resolve)
			},
			{
				path: 'logisticsDriverStatistics',
				meta: {
					title: '驾驶员统计'
				},
				name: 'LogisticsDriverStatistics',
				component: resolve => require(['@/views/logistics/operationManagement/driverStatistics/index.vue'], resolve)
			},
			{
				path: 'logisticsDriverTime',
				meta: {
					title: '驾驶员时间轴'
				},
				name: 'LogisticsDriverTime',
				component: resolve => require(['@/views/logistics/operationManagement/driverTime/index.vue'], resolve)
			},
			{
				path: 'logisticsCarTime',
				meta: {
					title: '车辆时间轴'
				},
				name: 'LogisticsCarTime',
				component: resolve => require(['@/views/logistics/operationManagement/carTime/index.vue'], resolve)
			},
			
			

			{
				path: 'logisticsRouteTransportationAnalysis',
				meta: {
					title: '运输分析'
				},
				name: 'LogisticsRouteTransportationAnalysis',
				component: resolve => require(['@/views/logistics/operationManagement/routeTransportationAnalysis/index.vue'], resolve)
			},


			{
				path: 'logisticsSuggestion',
				meta: {
					title: '匿名建议'
				},
				name: 'LogisticsSuggestion',
				component: resolve => require(['@/views/logistics/operationManagement/suggestion/index.vue'], resolve)
			},

			{
				path: 'logisticsVehicleMileage',
				meta: {
					title: '车辆里程'
				},
				name: 'LogisticsVehicleMileage',
				component: resolve => require(['@/views/logistics/operationManagement/vehicleMileage/index.vue'], resolve)
			},

			


			

		]
	},
	{
		path: '/logisticsGis',
		name: 'logistics_gis',
		component: AppContainer,
		meta: {
			title: 'GIS'
		},
		children: [
			{
				path: 'changtuMap',
				meta: {
					title: '昶途地图'
				},
				name: 'ChangtuMap',
				component: resolve => require(['@/views/logistics/gis/changtuMap/index.vue'], resolve)
			},
			{
				path: 'routeScouted',
				meta: {
					title: '路线探查'
				},
				name: 'LogisticsRouteScouted',
				component: resolve => require(['@/views/logistics/gis/scouted/index.vue'], resolve)
			}
		]
	},
	// 动态任务
	{
		path: '/logisticsDynamicTask',
		name: 'logistics_dynamic_task',
		component: AppContainer,
		meta: {
			title: '动态任务'
		},
		children: [
			{
				path: 'logisticsTemporaryDispatch',
				meta: {
					title: '临时派单'
				},
				name: 'LogisticsTemporaryDispatch',
				component: resolve => require(['@/views/logistics/dynamicTask/temporaryDispatch/index.vue'], resolve)
			},
			{
				path: 'logisticsTemporaryDispatchPay',
				meta: {
					title: '临时派单收款表'
				},
				name: 'LogisticsTemporaryDispatchPay',
				component: resolve => require(['@/views/logistics/dynamicTask/temporaryDispatchPay/index.vue'], resolve)
			}
		]
	},
	//财务管理
	{
		path: '/logisticsFinancialManagement',
		name: 'logistics_financial_management',
		component: AppContainer,
		meta: {
			title: '财务管理'
		},
		children: [
			{
				path: 'logisticsAccount',
				meta: {
					title: '费用报销'
				},
				name: 'LogisticsAccount',
				component: resolve => require(['@/views/logistics/financialManagement/account/index.vue'], resolve)
			},
			{
				path: 'logisticsWaybillrReimburse',
				meta: {
					title: '运单成本报销'
				},
				name: 'LogisticsWaybillrReimburse',
				component: resolve => require(['@/views/logistics/financialManagement/waybillrReimburse/index.vue'], resolve)
			},
			{
				path: 'logisticsProjectReceivable',
				meta: {
					title: '项目财务表'
				},
				name: 'LogisticsProjectReceivable',
				component: resolve => require(['@/views/logistics/financialManagement/projectReceivable/index.vue'], resolve)
			},
			{
				path: 'logisticsCustomerReceivable',
				meta: {
					title: '客户财务表'
				},
				name: 'LogisticsCustomerReceivable',
				component: resolve => require(['@/views/logistics/financialManagement/customerReceivable/index.vue'], resolve)
			},
			//报销统计
			{
				path: 'logisticsFinanciaChat',
				meta: {
					title: '报销统计'
				},
				name: 'LogisticsFinanciaChat',
				component: resolve => require(['@/views/logistics/financialManagement/financiaChat/index.vue'], resolve)
			},


			//路线财务表
			{
				path: 'logisticsFinanceRouteData',
				meta: {
					title: '路线财务表'
				},
				name: 'LogisticsFinanceRouteData',
				component: resolve => require(['@/views/logistics/financialManagement/financeRouteData/index.vue'], resolve)
			},
			
			
		]
	},

	//数据大屏
	{
		path: '/logisticsDataDashboard',
		name: 'logistics_data_dashboard',
		component: AppContainer,
		meta: {
			title: '途灵·智瞰'
		},
		children: [
			{
				path: 'scheduleDiagram',
				meta: {
					title: '调度一张图'
				},
				name: 'LogisticsScheduleDiagram',
				component: resolve => require(['@/views/logistics/dataDashboard/scheduleDiagram/index.vue'], resolve)
			},
			{
				path: 'logisticsOrderChat',
				meta: {
					title: '经营面板'
				},
				name: 'LogisticsOrderChat',
				component: resolve => require(['@/views/logistics/dataDashboard/businessAnalysis/index.vue'], resolve)
			},
			
		]
	},
]
